import React, { useCallback } from 'react';

import { SnackbarState } from '@/modules/core/core.types';
import { useSnackbar } from '@/modules/core/hooks';
import { RemovePaymentMethodModal as RemoveModal } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/RemovePaymentMethod';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';

interface Props {
  onSetVisible: (value: boolean) => void;
  refetchPaymentMethods: () => void;
}

const RemovePaymentMethodModal: React.FC<Props> = ({ onSetVisible, refetchPaymentMethods }) => {
  const { handleAddPermanentSnackbar } = useSnackbar();
  const editableMethod = useStore((state) => state.editableMethod);

  const handleClose = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  const handleRemoveSuccess = useCallback(() => {
    refetchPaymentMethods();
    handleClose();
    handleAddPermanentSnackbar({
      text: 'Payment method was deleted successfully',
      state: SnackbarState.positive,
      closeIcon: true,
      autoRemove: true,
    });
  }, [refetchPaymentMethods, handleAddPermanentSnackbar, handleClose]);

  return (
    <RemoveModal
      onClose={handleClose}
      onBack={handleClose}
      onSuccess={handleRemoveSuccess}
      methodForRemove={editableMethod}
    />
  );
};

export default RemovePaymentMethodModal;
